import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import history from './browserHistory';
import App from './app';
import {
  Auctions,
  AuctionTranscriptReport,
  EngineAdmin,
  Lanes,
  Members,
  ProductDetails,
  ProductImages,
  Products,
  ProxyBids,
} from './views/index';

import AppNew from './appNew';
import { getPath, memberType, allStaticLookupData } from './data';
const { authorized, registered, unique } = memberType;
const routePaths = getPath();
// console.log('allStaticLookupData', allStaticLookupData);
// TODO: It appears that we need to pass along state when clicking the breadcrumb links. The header text gets lost when we are on a page, then click the previous page, which showed the auction/lane information in the header.
const Routes = () => (
  <Router history={history}>
    <Switch>
      <Route exact path={routePaths.root.route} component={App} />
      <Route exact path={routePaths.login.route} component={App} />
      <Route exact path={routePaths.dashboard.route} component={App} />
      {/* <Route exact path={routePaths.auctions.route} component={Auctions} /> */}
      {/* <Route exact path={routePaths.auctions.route} component={App} /> */}

      
       <Route exact path={routePaths.auctions.route} render={(props)=> (
         <AppNew breadcrumbs={routePaths.auctions.breadcrumbs} {...props}>
           <Auctions {...props} />
         </AppNew>
       )} />
      <Route
        exact
        path={routePaths.auctionTranscriptReport.allAuctions.route}
        component={AuctionTranscriptReport}
      />
      <Route
        exact
        path={routePaths.engineAdmin.route}
        component={EngineAdmin}
      />
      <Route
        exact
        path={routePaths.auctionTranscriptReport.singleAuction.route}
        component={AuctionTranscriptReport}
      />
      <Route exact path={routePaths.auctionLanes.route} component={Lanes} />
      <Route
        exact
        path={routePaths.authorizedMembers.route}
        render={(props) => (
          <Members
            {...props}
            memberType={authorized.key}
            breadcrumbLocation={authorized.label}
          />
        )}
      />
      <Route
        exact
        path={routePaths.registeredMembers.route}
        render={(props) => (
          <Members
            {...props}
            memberType={registered.key}
            breadcrumbLocation={registered.label}
          />
        )}
      />
      <Route
        exact
        path={routePaths.uniqueMembers.route}
        render={(props) => (
          <Members
            {...props}
            memberType={unique.key}
            breadcrumbLocation={unique.label}
          />
        )}
      />
      <Route exact path={routePaths.proxyBids.route} component={ProxyBids} />
      <Route
        exact
        path={routePaths.auctionMediaStateProducts.route}
        component={Products}
      />
      <Route
        exact
        path={routePaths.auctionLaneMediaStateProducts.route}
        component={Products}
      />
      <Route
        exact
        path={routePaths.auctionProducts.route}
        component={Products}
      />
      <Route
        exact
        path={routePaths.auctionLaneProducts.route}
        component={Products}

      />
      <Route
        exact
        path={routePaths.auctionProductImages.route}
        component={ProductImages}
      />
      <Route
        exact
        path={routePaths.auctionLaneProductImages.route}
        component={ProductImages}
      />
      <Route
        exact
        path={routePaths.auctionMediaStateProductImages.route}
        component={ProductImages}
      />
      <Route
        exact
        path={routePaths.auctionLaneMediaStateProductImages.route}
        component={ProductImages}
      />
      <Route
        exact
        path={routePaths.auctionLaneProductDetails.route}
        component={ProductDetails}
      />
    </Switch>
  </Router>
);

export default Routes;
